// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2311":"3bcec942","5921":"31d6cfe0","6327":"daff6e12","8637":"3b047748"}[chunkId] + ".chunk.css";
};